import { color as colors } from "@styles";
import { Cloud } from "components/atoms/Cloud";
import { FC } from "react";

type Props = {
  color: string;
};

export const Clouds: FC<Props> = ({ color = colors.S320 }) => (
  <>
    <Cloud id="GCI-hero-cloud1" color={color} scale={1.8} top="20%" left="15%" animated />
    <Cloud
      id="GCI-hero-cloud2"
      color={color}
      scale={1.41}
      reversed
      top="21%"
      right="15%"
      animated
    />
    <Cloud
      id="GCI-hero-cloud3"
      color={color}
      scale={0.81}
      reversed
      top="33%"
      right="50%"
      animated
      hideOnMobile
    />
    <Cloud
      id="GCI-hero-cloud4"
      color={color}
      scale={1.4}
      reversed
      bottom="47%"
      right="40%"
      animated
    />
  </>
);
